var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.vacancy)?_c('div',[_c('div',{staticClass:"mb-3"},[_c('IntegrationsInviteMethod',{attrs:{"vacancy":_vm.vacancy}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }